import { useStaticQuery, graphql } from 'gatsby';

export const useSettings = () => {
  const { settingsJson } = useStaticQuery(graphql`
    query {
      settingsJson {
        ...SettingsData
      }
    }
  `);
  return settingsJson;
};
